module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zhubo-player"
  }, [(_vm.userInfo && _vm.userInfo.backgroundUrl) ? _c('div', {
    staticClass: "zhubo-cover"
  }, [_c('div', {
    staticClass: "zhubo-cover-box"
  }, [_c('img', {
    staticClass: "zhubo-cover-img",
    attrs: {
      "src": _vm.userInfo.backgroundUrl,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('video', {
    staticClass: "zhubo-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xtzb-item-user"
  }, [_c('span', {
    staticClass: "xtzb-item-user-sort"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "xtzb-item-user-name"
  }, [_vm._v("主播")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee6a24a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zhuboplayer/zhuboplayer.vue
// module id = 1006
// module chunks = 1